export default __webpack_public_path__ + "assets/chevron-up-component.f98491eb.svg";